import { PREFIXO_ICONE_ZIP } from './kmzKmlPreview';

const cache = new Map();
const VERDE_PARQUE = '#188038';

function arquivoDoIcone(url) {
  const partes = String(url || '').split('/');
  return partes[partes.length - 1] || '';
}

function ehParque(url) {
  return arquivoDoIcone(url) === 'parks.png';
}

function tamanhoDoIcone(url) {
  const arquivo = arquivoDoIcone(url);
  if (arquivo === 'triangle.png') return 30;
  if (arquivo === 'placemark_square.png') return 14;
  if (arquivo === 'parks.png') return 44;
  return 16;
}

function hexParaRgb(cor) {
  const hex = String(cor || '#808080').replace('#', '');
  const full = hex.length === 3 ? hex.split('').map((char) => char + char).join('') : hex;
  return [
    parseInt(full.slice(0, 2), 16) || 0,
    parseInt(full.slice(2, 4), 16) || 0,
    parseInt(full.slice(4, 6), 16) || 0,
  ];
}

function carregarIcone(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(url));
    image.src = url;
  });
}

function pintarSolido(image, cor, tamanho) {
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const context = canvas.getContext('2d');
  context.drawImage(image, 0, 0);
  context.globalCompositeOperation = 'source-in';
  context.fillStyle = cor;
  context.fillRect(0, 0, canvas.width, canvas.height);
  return {
    data: context.getImageData(0, 0, canvas.width, canvas.height),
    pixelRatio: image.width / tamanho,
  };
}

function tingirIcone(image, cor, tamanho) {
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const context = canvas.getContext('2d');
  context.drawImage(image, 0, 0);
  const imagem = context.getImageData(0, 0, canvas.width, canvas.height);
  const dados = imagem.data;
  const [r, g, b] = hexParaRgb(cor);
  for (let i = 0; i < dados.length; i += 4) {
    if (dados[i + 3] < 16) continue;
    const luz = (dados[i] + dados[i + 1] + dados[i + 2]) / 3;
    if (luz < 150) {
      dados[i] = 0;
      dados[i + 1] = 0;
      dados[i + 2] = 0;
    } else {
      dados[i] = r;
      dados[i + 1] = g;
      dados[i + 2] = b;
    }
  }
  context.putImageData(imagem, 0, 0);
  return {
    data: context.getImageData(0, 0, canvas.width, canvas.height),
    pixelRatio: image.width / tamanho,
  };
}

function ehIconeDoZip(url) {
  return String(url || '').startsWith(PREFIXO_ICONE_ZIP);
}

function desenharNoCanvas(image) {
  const canvas = document.createElement('canvas');
  canvas.width = image.width;
  canvas.height = image.height;
  const context = canvas.getContext('2d');
  context.drawImage(image, 0, 0);
  return { context, canvas };
}

// PNG do KMZ: o que o arquivo trouxe, no tamanho que trouxe.
function iconeDoZip(image, cor) {
  const { context, canvas } = desenharNoCanvas(image);
  const imagem = context.getImageData(0, 0, canvas.width, canvas.height);
  if (cor) {
    // IconStyle/color no KML multiplica a cor do pixel, sem mexer no alfa
    const [r, g, b] = hexParaRgb(cor);
    const dados = imagem.data;
    for (let i = 0; i < dados.length; i += 4) {
      dados[i] = Math.round((dados[i] * r) / 255);
      dados[i + 1] = Math.round((dados[i + 1] * g) / 255);
      dados[i + 2] = Math.round((dados[i + 2] * b) / 255);
    }
  }
  return { data: imagem, pixelRatio: 1 };
}

export async function garantirIconesKmz(map, collection, ativo, recursos) {
  const pares = new Map();
  ((collection && collection.features) || []).forEach((feature) => {
    const properties = feature.properties || {};
    const url = properties.iconeUrl;
    if (!url || !feature.geometry || feature.geometry.type !== 'Point') return;
    // mesma regra do icon-image em KmzVisualizacaoMap: corIcone manda, '' deixa o PNG como veio
    const cor = properties.corIcone !== undefined && properties.corIcone !== null
      ? properties.corIcone
      : (properties.corResolvida || '#808080');
    pares.set(`${url}|${cor}`, { url, cor });
  });
  await Promise.all([...pares.entries()].map(async ([id, { url, cor }]) => {
    if (!ativo() || !map.getStyle() || map.hasImage(id)) return;
    const doZip = ehIconeDoZip(url);
    const origem = doZip ? recursos && recursos[url] : url;
    if (!origem) return;
    try {
      let bitmap = doZip ? null : cache.get(id);
      if (!bitmap) {
        const image = await carregarIcone(origem);
        if (doZip) bitmap = iconeDoZip(image, cor);
        else if (ehParque(url)) bitmap = pintarSolido(image, VERDE_PARQUE, tamanhoDoIcone(url));
        else bitmap = tingirIcone(image, cor, tamanhoDoIcone(url));
        // o conteúdo de um ícone do zip muda de arquivo para arquivo, então ele não entra no cache
        if (!doZip) cache.set(id, bitmap);
      }
      if (!ativo() || !map.getStyle() || map.hasImage(id)) return;
      map.addImage(id, bitmap.data, { pixelRatio: bitmap.pixelRatio });
    } catch (error) {
      // ícone que não carrega deixa só aquele ponto sem símbolo
    }
  }));
}
